"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireWildcard(require("react"));
const SvgComponent = (_ref, ref) => {
  let {
    fillColor = (0, _designTokensReact.color)("color--background--neutral--strongest"),
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    fill: fillColor,
    width: size.width,
    height: size.height,
    viewBox: "0 0 8 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.25 3.8a.7.7 0 1 0 0 1.4h3.5a.7.7 0 1 0 0-1.4h-3.5ZM2.25 6.8a.7.7 0 1 0 0 1.4h3.5a.7.7 0 1 0 0-1.4h-3.5ZM1.55 10.5a.7.7 0 0 1 .7-.7h3.5a.7.7 0 1 1 0 1.4h-3.5a.7.7 0 0 1-.7-.7ZM2.25 12.8a.7.7 0 1 0 0 1.4h3.5a.7.7 0 1 0 0-1.4h-3.5Z"
  }));
};
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=DragHandleIconSvg.js.map